
@custom-media --mobile (max-width: 768px);

.navigation {
  margin-top: 2em;
  display: flex;
  justify-content: center;
  margin-bottom: 2em;

  & > * {
    margin-left: 1em;
  }

  @media (--mobile) {
    margin-top: 0;
  }
}

.pageButton {
  &:disabled,
  &:disabled:hover {
    cursor: default;
    background-color: var(--darkBlue) !important;
  }
}

.more {
  padding-top: 0.75em;
}
